<template>
<div class="chapter">
<div class="inner_page">
<div class="frame-2"><img alt="TitleBlock" class="frame-6" src="Images/TitleBlock.jpg"/></div>
<p class="Basic-Paragraph"> </p>
<p class="Basic-Paragraph"> </p>
<div class="frame-2"><img alt="PELOGO.TIF" class="frame-3" src="Images/PELOGO_fmt.jpeg"/></div>
<p class="Basic-Paragraph para-style-override-5">PELICAN PUBLISHING COMPANY</p>
<p class="Basic-Paragraph para-style-override-6">Gretna 2016</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FullTitle.vue?57f69400